import * as React from 'react';
import styled from 'styled-components';
import { Layout, Form, Button, Card } from 'antd';

export const singleColFormColSize = {
  labelCol: {
    xs: { span: 9 },
    md: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 14 },
    md: { span: 17 },
  },
};

export const doubleColFormColSize = {
  labelCol: {
    xs: { span: 9 },
    md: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 15 },
    md: { span: 17 },
  },
};

export const FullWithButton = styled(Button)`
  width: 100%;
`;

export const VMFullWithButton = styled(FullWithButton)`
  width: 100%;
  margin-top: '10px';
  color: 'white';
`;

export const WhiteBackgroundCard = styled(Card)`
  background-color: white;
  min-height: 60vh;
  padding-bottom: 50px;
`;
